var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66371 10.3192L0.061875 18.1063C0.0449609 18.0279 0.0195312 17.9521 0.0195312 17.8663V4.13332C0.0195312 4.0291 0.0472656 3.93493 0.0725 3.84031L6.66371 10.3192ZM19.2964 3.1873C19.248 3.17594 19.2017 3.15137 19.1483 3.15137H0.852305C0.801641 3.15137 0.756367 3.17594 0.705078 3.1873L10.0004 12.3229L19.2964 3.1873ZM10.2659 13.3385C10.1896 13.4152 10.0952 13.4524 10.0004 13.4524C9.90594 13.4524 9.81129 13.4152 9.73578 13.3385L7.3057 10.9507L0.650625 18.7987C0.716953 18.8202 0.782031 18.8482 0.852305 18.8482H19.1483C19.2221 18.8482 19.2864 18.8202 19.3531 18.7987L12.6985 10.9507L10.2659 13.3385ZM13.3396 10.3192L19.9404 18.1054C19.9583 18.027 19.9804 17.9512 19.9804 17.8663V4.13332C19.9804 4.03082 19.9562 3.93493 19.9312 3.84076L13.3396 10.3192Z",
    fill: "#4F5660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGray);
export default __webpack_public_path__ + "static/media/EmailGray.44b73fe8dd1f82f2ff352628c7e056c4.svg";
export { ForwardRef as ReactComponent };